module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_8017.d0211e3a.png";